import styled from 'styled-components'

interface ICollapsibleContentStyledProps {}

export const CollapsibleContentStyled = styled.div<ICollapsibleContentStyledProps>``
